import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";

class CampaignsTitle extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleHelp: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      nameSize: this.props.campaign.name.length || 0,
      editMode: false,
      name: this.props.campaign.name
    };
  }

  onRenameClick() {
    this.setState({ editMode: true });
  }

  onSaveClick(e) {
    this.props.handleSave(this.props.campaign.id, {
      name: this.state.name
    });
    this.setState({ editMode: false });
  }

  onCancelClick() {
    let newNameSize = this.props.campaign.name.length;
    this.setState({
      editMode: false,
      name: this.props.campaign.name,
      nameSize: newNameSize
    });
  }

  handleChange(e) {
    let newName = e.target.value;
    let newNameSize = newName.length;
    this.setState({
      name: newName,
      nameSize: newNameSize
    });
  }

  showIfStarterCampaign() {
    if (this.props.campaign.type == "StarterCampaign") {
      return <span> [StarterWorkflow]</span>;
    }
  }
  render() {
    if (this.state.editMode == false) {
      return (
        <h1 className="campaign_title_h2">
          <div className="name_form">
            <FormControl
              type="input"
              className="form-control campaign_title hide_border"
              labelClassName=""
              wrapperClassName=""
              size={this.state.nameSize}
              value={this.state.name}
            />
          </div>
          <button
            bsStyle="default"
            className="btn btn-sm btn-primary help_icon_smaller"
            onClick={this.props.handleHelp.bind(this)}
          >
            ?
          </button>
          <button
            className="btn btn-default m-l-10 rename_campaign_btn"
            onClick={this.onRenameClick.bind(this)}
          >
            Rename
          </button>
          {this.showIfStarterCampaign()}
        </h1>
      );
    } else {
      return (
        <h2 className="campaign_title_h2">
          <div className="name_form">
            <FormControl
              type="input"
              className="form-control campaign_title"
              labelClassName=""
              wrapperClassName=""
              size={this.state.nameSize}
              value={this.state.name}
              onChange={this.handleChange.bind(this)}
            />
          </div>
          <button
            bsStyle="default"
            className="btn btn-sm btn-primary help_icon_smaller"
            onClick={this.props.handleHelp.bind(this)}
          >
            ?
          </button>
          <button
            className="btn btn-success m-l-10"
            onClick={this.onSaveClick.bind(this)}
          >
            {" "}
            Save{" "}
          </button>
          <button
            className="btn btn-default m-l-10"
            onClick={this.onCancelClick.bind(this)}
          >
            {" "}
            Cancel{" "}
          </button>
        </h2>
      );
    }
  }
}

export default CampaignsTitle;
